exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.exchange-rates[data-v-97a386de] {\n  max-width: 560px;\n  width: 100%;\n  min-width: 248px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n@media only screen and (max-width: 1023px) {\n.exchange-rates[data-v-97a386de] {\n      max-width: inherit;\n}\n}\n.exchange-rates[data-v-97a386de] .md-table-cell-container {\n    padding: 6px 12px;\n}\n.exchange-rates__header[data-v-97a386de] {\n  padding-bottom: 48px;\n}\n.ex-head-currency[data-v-97a386de] {\n  width: 20%;\n  text-align: left;\n}\n.ex-head-buy[data-v-97a386de] {\n  width: 40%;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-97a386de","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/exchange/index/Exchange.Rates.vue
// module id = YwKp
// module chunks = 1